export const updateColumnsOrder = (gridIndex: number, columns: string[]) =>
  ({
    type: 'grid.updateColumnsOrder',
    payload: { gridIndex, columns }
  } as const)
export type UpdateColumnsOrderAction = ReturnType<typeof updateColumnsOrder>

export const updateGridState = (gridIndex: number, columns: string[]) =>
  ({ type: 'grid.updateGridState', payload: { gridIndex, columns } } as const)
export type updateGridStateAction = ReturnType<typeof updateGridState>

export const resetColumnsForGrid = (gridIndex: number) =>
  ({ type: 'grid.resetColumnsForGrid', payload: { gridIndex } } as const)
export type ResetColumnsForGridAction = ReturnType<typeof resetColumnsForGrid>

export type GridAction =
  | updateGridStateAction
  | UpdateColumnsOrderAction
  | ResetColumnsForGridAction
